import axios from "axios";
import { StockStamps } from "@/models/stock-stamps";

export const getStockStamps = async (stockId: number) => {
    const res = await axios.get<StockStamps>(`/API/v2/id/${stockId}/stock_stamp`);

    return res.data;
};
